import { watch } from 'vue';

export default defineNuxtPlugin({
  name: 'subscription-service-property',
  dependsOn: ['pinia-persistence'],

  setup() {
    const gatewayStore = useKegelGatewayStore();
    const { setUserProperty } = useMixpanel();

    watch(
      () => gatewayStore.subscriptionService,
      (subscriptionService) => {
        if (!subscriptionService) return;

        setUserProperty({ subscription_service: subscriptionService });
      },
      { immediate: true },
    );
  },
});
